import { isPast } from 'date-fns';

const isInThePast = date => {
  return isPast(new Date(date));
};

export default isInThePast;
